import React from 'react';

const HomeContactSection = () => {
  return (
    <section id="contact" aria-labelledby="contact-title" className="site-bg-section py-20 px-6">
      <div className="container mx-auto text-center max-w-2xl">
        <h2
          id="contact-title"
          className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
        >
          Vamos nos conectar
        </h2>
        <p className="mt-6 text-lg text-gray-600">
          Estou sempre aberto a discutir novos projetos ou sobre tecnologia ou alguma coisa que
          achar interessante aqui, se quiser conversar pode entrar em contato comigo.
        </p>
        <div className="mt-10">
          <a
            href="mailto:guilhermeportella.dev@gmail.com"
            className="text-xl text-blue-600 font-semibold hover:underline"
          >
            guilhermeportella.dev@gmail.com
          </a>
        </div>
        <div className="flex justify-center space-x-6 mt-6">
          <a
            href="https://github.com/GuilhermePortella"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-gray-800"
          >
            GitHub
          </a>
          <a
            href="https://www.linkedin.com/in/myprofileguilhermeportella/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-gray-800"
          >
            LinkedIn
          </a>
          <a
            href="https://x.com/BYTE_GHOST404"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-500 hover:text-gray-800"
          >
            Twitter
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeContactSection;
